<template>
  <el-card class="review-way">
    <template v-if="readOnly">
      <div class="title">{{ form.title }}</div>
      <div v-if="isRankByQuote && isQuoteReview" class="no-reviw-box">
        已设置为最低价法，价格分评审无需设置，系统会根据供应商报价自动排序
      </div>
      <div v-else>
        <el-form
          v-if="isScore"
          ref="scoreSettingForm"
          :model="form"
          label-width="100px"
          inline
          label-suffix=":"
        >
          <el-form-item label="评审总分值" prop="scoreSum">
            <span>{{ form.scoreSum }}</span>
          </el-form-item>
          <el-form-item v-if="showScoreMethod" label="评分方案">
            <span>
              {{
                inquiryReviewScoringSchemeDict.translate(form.scoreMethod).label
              }}
            </span>
          </el-form-item>
          <el-form-item label="分项总分值">
            <span class="total-score-text">{{ totalScore }}</span>
          </el-form-item>
        </el-form>
        <el-table :data="form.itemInfoList" border>
          <el-table-column
            :label="`${wayItemLabel}点序号`"
            type="index"
            prop="orderNum"
            width="90px"
          />
          <el-table-column
            :label="`${wayItemLabel}点名称`"
            prop="itemName"
            width="200px"
          />
          <el-table-column
            v-if="isScore"
            label="分值区间"
            prop="maxScore"
            width="200px"
          >
            <template v-slot:default="{ row }">
              <span>{{ row.minScore }} ~ {{ row.maxScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="`${wayItemLabel}标准`"
            prop="itemStandard"
            min-width="260px"
          />
        </el-table>
      </div>
    </template>
    <template v-else>
      <div class="title">{{ form.title }}</div>
      <div v-if="isRankByQuote && isQuoteReview" class="no-reviw-box">
        已设置为最低价法，价格分评审无需设置，系统会根据供应商报价自动排序
      </div>
      <div v-else>
        <el-form
          v-if="isScore"
          ref="scoreSettingForm"
          :model="form"
          :rules="rules"
          label-width="100px"
          inline
          label-suffix=":"
        >
          <el-form-item label="评审总分值" prop="scoreSum">
            <el-input-number
              v-model="form.scoreSum"
              controls-position="right"
              :min="0"
              :max="100"
            />
          </el-form-item>
          <el-form-item
            v-if="showScoreMethod"
            label="评分方案"
            prop="scoreMethod"
          >
            <el-select
              v-model="form.scoreMethod"
              placeholder="请选择"
              @change="changeScoreMethod"
            >
              <el-option
                v-for="item in inquiryReviewScoringSchemeDict.array"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.wayType === inquiryReviewTypeDict.BUSINESS.value"
            label="分项总分值"
          >
            <span class="total-score-text">{{ totalScore }}</span>
          </el-form-item>
        </el-form>
        <el-form ref="listForm" :model="form">
          <el-table :data="form.itemInfoList" border>
            <el-table-column
              :label="`${wayItemLabel}点序号`"
              type="index"
              prop="orderNum"
              width="90px"
            >
              <template v-slot:default="{ $index }">
                <el-form-item>
                  <span>{{ $index + 1 }}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              :label="`${wayItemLabel}点名称`"
              prop="itemName"
              width="200px"
            >
              <template v-slot:header>
                <span class="require-tag">*</span>
                <span>{{ wayItemLabel }}点名称</span>
              </template>
              <template v-slot:default="{ row, $index }">
                <el-form-item
                  :prop="'itemInfoList.' + $index + '.itemName'"
                  :rules="rules.itemName"
                >
                  <el-input
                    v-model.trim="row.itemName"
                    placehlder="请输入"
                    :maxlength="50"
                    show-word-limit
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isScore"
              label="分值区间"
              prop="maxScore"
              width="200px"
            >
              <template v-slot:header>
                <span class="require-tag">*</span>
                <span>分值区间</span>
              </template>
              <template v-slot:default="{ row, $index }">
                <el-form-item
                  :prop="'itemInfoList.' + $index + '.maxScore'"
                  :rules="[
                    rules.maxScore,
                    {
                      validator: validTotalScore,
                      trigger: 'blur',
                      minScore: row.minScore
                    }
                  ]"
                >
                  <div class="u-flex">
                    <el-input-number
                      v-model="row.minScore"
                      style="width: 70px"
                      placeholder="请输入"
                      :controls="false"
                      :precision="2"
                      :min="0"
                      controls-position="right"
                    />
                    <span class="m-r-10 m-l-10">至</span>
                    <el-input-number
                      v-model="row.maxScore"
                      style="width: 70px"
                      placeholder="请输入"
                      :controls="false"
                      :precision="2"
                      controls-position="right"
                    />
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              :label="`${wayItemLabel}标准`"
              prop="itemStandard"
              min-width="260px"
            >
              <template v-slot:header>
                <span class="require-tag">*</span>
                <span>{{ wayItemLabel }}标准</span>
              </template>
              <template v-slot:default="{ row, $index }">
                <el-form-item
                  :prop="'itemInfoList.' + $index + '.itemStandard'"
                  :rules="rules.itemStandard"
                >
                  <el-input
                    v-model.trim="row.itemStandard"
                    placehlder="请输入"
                    :maxlength="999"
                    type="textarea"
                    :rows="3"
                    show-word-limit
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140px">
              <template v-slot:default="{ $index }">
                <el-form-item>
                  <el-button
                    v-if="$index !== 0"
                    type="text"
                    @click="upWayItem($index)"
                  >
                    上移
                  </el-button>
                  <el-button
                    v-if="showDownWayItem($index)"
                    type="text"
                    @click="downWayItem($index)"
                  >
                    下移
                  </el-button>
                  <el-button
                    type="text"
                    class="text-danger"
                    @click="removeWayItem($index)"
                  >
                    删除
                  </el-button>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div v-if="showAddBtn" class="add-button" @click="addWayItem">
          <i class="el-icon-plus"></i>
          新增评审点
        </div>
      </div>
    </template>
  </el-card>
</template>

<script>
import { countRepeatNum, moveInArray } from '@/utils/utils'
import { requiredRule } from '@/utils/form-validate'
import { cloneDeep, isEqual } from 'lodash'
import {
  onlineReviewMethodDict,
  inquiryReviewScoringSchemeDict,
  inquiryReviewTypeDict
} from '@/dictionary/project/online-review'

import { inquiryReviewModelDict } from '@/dictionary/project/inquiry'

/**
 * @description 询比在线评审办法
 */
export default {
  name: 'InquiryReviewWay',

  model: {
    prop: 'info',
    event: 'change'
  },

  props: {
    info: {
      type: Object,
      default: () => {}
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    reviewModel: {
      type: [Number, String],
      default: inquiryReviewModelDict.SYNTHESIS.value
    }
  },

  data() {
    return {
      inquiryReviewScoringSchemeDict,
      inquiryReviewTypeDict,
      inquiryReviewModelDict,

      form: {
        // 序号
        orderNum: '',
        // 评审办法类型
        wayType: '',
        // 评审方式
        reviewMethod: '',
        // 评审总分
        scoreSum: '',
        // 评分方案
        scoreMethod: '',
        // 评审点列表
        itemInfoList: []
      },

      // 当前操作的评审点序号
      editIndex: ''
    }
  },

  computed: {
    // 是评分类的评审点
    isScore() {
      return this.form.reviewMethod === onlineReviewMethodDict.SCORE.value
    },

    wayItemLabel() {
      if (this.isScore) {
        return '评分'
      } else {
        return '评审'
      }
    },

    // 评分点最高分累计值
    totalScore() {
      const result = this.form.itemInfoList.reduce((total, item) => {
        const maxScoreNum = isNaN(Number(item.maxScore))
          ? 0
          : Number(item.maxScore)
        return Number(total) + maxScoreNum * 10000
      }, 0)
      return result / 10000
    },

    rules() {
      return {
        scoreMethod: requiredRule('评分方式不能为空', '', 'blur'),
        scoreSum: [
          requiredRule('评审总分不能为空不能为空'),
          { validator: this.validateScoreSum, trigger: 'blur' }
        ],
        itemName: [
          requiredRule(`${this.wayItemLabel}点名称不能为空`),
          { validator: this.validateName, trigger: 'blur' }
        ],
        itemStandard: [
          requiredRule(`${this.wayItemLabel}标准不能为空`),
          {
            validator: (rule, value, callback) => {
              if (value.length > 999) {
                callback(new Error('不能超过999个字'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        reviewType: requiredRule('评分点类型不能为空'),
        maxScore: requiredRule('分值区间不能为空'),
        relationCatalog: {
          catalogName: { validator: this.validCatalog, trigger: 'change' }
        }
      }
    },

    showAddBtn() {
      if (this.isQuoteReview && this.form.itemInfoList.length === 1) {
        return false
      } else {
        return true
      }
    },

    // 是价格分评审
    isQuoteReview() {
      return this.info.wayType === inquiryReviewTypeDict.QUOTATION.value
    },

    isRankByQuote() {
      return (
        Number(this.reviewModel) === inquiryReviewModelDict.LOWEST_MARK.value
      )
    },

    showScoreMethod() {
      // 目前仅综合评审需要，价格分默认选择平均分
      if (this.info.wayType === inquiryReviewTypeDict.BUSINESS.value) {
        return true
      }
      return false
    }
  },

  watch: {
    info: {
      handler(val) {
        if (val?.title) {
          this.form = cloneDeep(val)
          if (val.wayType === inquiryReviewTypeDict.BUSINESS.value) {
            this.form.scoreMethod = inquiryReviewScoringSchemeDict.AVERAGE.value
          }
          if (this.form.scoreMethod <= 0) {
            this.form.scoreMethod = ''
          }
        }
      },
      deep: true,
      immediate: true
    },

    form: {
      handler(val) {
        if (!isEqual(val, this.info)) this.$emit('change', cloneDeep(val))
      },
      deep: true
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.scoreSettingForm) {
        this.$refs.scoreSettingForm.clearValidate()
      }
      if (this.$refs.listForm) {
        this.$refs.listForm.clearValidate()
      }
    })
  },

  methods: {
    /**
     * 添加评审点
     */
    addWayItem() {
      const wayItem = {
        // 序号
        orderNum: this.form.itemInfoList.length + 1,
        // 评审点名称
        itemName: '',
        // 评审标准
        itemStandard: '',
        // 最低分
        minScore: '',
        // 最高分
        maxScore: ''
      }
      this.form.itemInfoList.push(wayItem)
      this.editIndex = wayItem.orderNum
    },

    /**
     * 删除评审点
     */
    removeWayItem(index) {
      this.form.itemInfoList.splice(index, 1)
    },

    /**
     * 上移评审点
     */
    upWayItem(index) {
      moveInArray(this.form.itemInfoList, index, index - 1)
      this.form.itemInfoList.forEach((item, index) => {
        item.orderNum = index + 1
      })
    },

    showDownWayItem(index) {
      if (this.form.itemInfoList.length === 1) {
        return false
      }
      return index !== this.form.itemInfoList.length - 1
    },

    /**
     * 下移评审点
     */
    downWayItem(index) {
      moveInArray(this.form.itemInfoList, index, index + 1)
      this.form.itemInfoList.forEach((item, index) => {
        item.orderNum = index + 1
      })
    },

    /**
     * 验证评审总分值
     */
    validateScoreSum(rule, value, callback) {
      const pointTotalScore =
        this.form.itemInfoList.length > 0 ? this.totalScore : 0

      if (this.alreadyScore > 100) {
        callback(new Error('各评审办法的总分值不能超过100'))
      } else if (value < pointTotalScore) {
        callback(new Error('各评分点最高分值总和不能高于设定的评分总值'))
      } else {
        callback()
      }
    },

    /**
     * 验证评审点名称
     */
    validateName(rule, value, callback) {
      if (value.length > 50) {
        callback(new Error('不能超过50个字'))
        return
      }
      const repeatObj = countRepeatNum(this.form.itemInfoList, 'itemName')
      if (repeatObj[value].num > 1) {
        callback(new Error('当前评审点名称已存在'))
        return
      }
      callback()
    },

    /**
     * 验证评审点最高分
     */
    validTotalScore(rule, value, callback) {
      const list = this.form.itemInfoList
      const listTotalScore = list.length > 0 ? this.totalScore : 0

      if (!this.form.scoreSum) {
        callback(new Error('请先设置评审总分值'))
      }
      if (listTotalScore > parseFloat(this.form.scoreSum)) {
        callback(
          new Error(
            '各评分点最高分值总和不能高于设定的评分总值，请修改最高分值'
          )
        )
      } else if (value <= rule.minScore) {
        callback(new Error('最高分值不能低于或等于最低分值'))
      } else {
        callback()
      }
    },

    validCatalog(rule, value, callback) {
      const index = this.catalogList.findIndex(
        item => item.catalogName === value
      )
      if (index < 0 && value) {
        callback(new Error('目录不存在，请重新选择目录'))
      } else {
        callback()
      }
    },

    changeRelationCatalog(index) {
      const relationCatalog = this.form.itemInfoList[index].relationCatalog
      if (relationCatalog.catalogName) {
        const catalog = this.catalogList.find(
          item => item.catalogName === relationCatalog.catalogName
        )
        if (catalog) {
          relationCatalog.catalogType = catalog.catalogType
          relationCatalog.orderNum = catalog.orderNum
        } else {
          relationCatalog.catalogName = ''
        }
      }
    },

    validateListForm() {
      return new Promise((resolve, reject) => {
        Promise.allSettled(
          [
            this.$refs.scoreSettingForm
              ? this.$refs.scoreSettingForm.validate()
              : null,
            this.$refs.listForm.validate()
          ].filter(value => value)
        ).then(res => {
          if (res.some(item => item.status === 'rejected')) {
            this.$message.error(`${this.info.title}设置有误，请重新设置`)
            reject()
            return
          }
          if (this.form.itemInfoList.length === 0) {
            this.$message.error(`请添加${this.info.title}的评审点`)
            reject()
            return
          }
          if (Number(this.form.scoreSum) !== Number(this.totalScore)) {
            this.$message.error(
              `${this.info.title}分项总分值不等于评审总分值，提交失败`
            )
            reject()
            return
          }
          resolve(true)
        })
      })
    },

    changeScoreMethod() {
      this.$emit('update:scoreSetting', this.form)
    }
  }
}
</script>

<style scoped lang="scss">
.review-way {
  .title {
    font-size: 16px;
    color: $text-color;
    margin-bottom: 16px;
  }
}

.add-button {
  width: 100%;
  padding: 4px 0;
  border: 1px dashed $border-color;
  border-radius: 4px;
  text-align: center;
  margin-top: 16px;
  cursor: pointer;

  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
}

.total-score-text {
  color: $danger-color;
}
.no-reviw-box {
  background: $info-fifth-color;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 26px;
}

.require-tag {
  color: $danger-color;
  margin-right: 8px;
}

::v-deep .el-input__inner {
  padding-right: 46px;
}

::v-deep .el-textarea .el-input__count {
  bottom: -32px;
  background: transparent;
}
</style>
